import React from 'react';
import { HeroSection } from './components/HeroSection';
import { TransformationSection } from './components/TransformationSection';
import { ProblemSection } from './components/ProblemSection';
import { ResultsSection } from './components/ResultsSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { MockupShowcaseSection } from './components/MockupShowcaseSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AudienceSection } from './components/AudienceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTASection } from './components/FinalCTASection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <div className="min-h-screen bg-[#fffdf9] text-[#6b4f3a] font-sans selection:bg-[#f8d7da] selection:text-[#6b4f3a]" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <TransformationSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <ResultsSection data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <MockupShowcaseSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <AudienceSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FinalCTASection data-id="element-12" />
        <FAQSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
    </div>;
}